import type {PropsWithChildren} from 'react';

export enum PerformanceDrawerTab {
  REACH = 'reach',
  EARNINGS = 'earnings',
}

/** Left-to-right order of every tab the strip can show. */
export const PERFORMANCE_DRAWER_TAB_ORDER: PerformanceDrawerTab[] = Object.values(PerformanceDrawerTab);

export interface PromotionPerformanceDrawerProps extends PropsWithChildren {
  isOpen: boolean;
  /** The tabs this viewer and event may see, in strip order; also the arrow-key traversal order. */
  tabs: PerformanceDrawerTab[];
  activeTab: PerformanceDrawerTab;
  onTabChange: (tab: PerformanceDrawerTab) => void;
  onClose: VoidFunction;
  className?: string;
}

/** Translation key for each tab's label. */
export const PERFORMANCE_DRAWER_TAB_LABEL_KEYS: Record<PerformanceDrawerTab, string> = {
  [PerformanceDrawerTab.REACH]: 'pmwjs_reach',
  [PerformanceDrawerTab.EARNINGS]: 'pmwjs_earnings',
};

/** Each tab's icon: `4646:26699` and `5532:52266`. */
export const PERFORMANCE_DRAWER_TAB_ICONS: Record<PerformanceDrawerTab, string> = {
  [PerformanceDrawerTab.REACH]: 'icon-megaphone',
  [PerformanceDrawerTab.EARNINGS]: 'icon-coins',
};

/** The drawer's title per tab: Reach (`5532:52266`) keeps Performance, Earnings (`4646:26699`) names itself. */
export const PERFORMANCE_DRAWER_TITLE_KEYS: Record<PerformanceDrawerTab, string> = {
  [PerformanceDrawerTab.REACH]: 'pmwjs_performance',
  [PerformanceDrawerTab.EARNINGS]: 'pmwjs_earnings',
};

/** Translation key for the tablist's aria-label. Distinct from the drawer heading so AT doesn't read "Performance" twice. */
export const PERFORMANCE_DRAWER_TABLIST_ARIA_LABEL_KEY = 'pmwjs_performance_metrics';

export const PERFORMANCE_DRAWER_PANEL_ELEMENT_ID = 'promotion-performance-drawer-panel';

export const PERFORMANCE_DRAWER_CLOSE_ICON = 'icon-close';

/**
 * Makes the drawer heading programmatically focusable without putting it in the tab order, so opening the
 * drawer can land the caret on it. `Text` passes its `attributes` straight through to the element it renders.
 */
export const PERFORMANCE_DRAWER_HEADING_ATTRIBUTES: Record<string, string> = {tabIndex: '-1'};

